/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by Rubeniskov <ruben.lopez@spazious.com>, Thu Feb 15 2024
 */

import React from 'react';
import ReactReconciler from 'react-reconciler';

import { HostConfig } from './host.js';

const reconciler = ReactReconciler(HostConfig);
const { updateContainer, createContainer, injectIntoDevTools } = reconciler;
injectIntoDevTools({
  bundleType: process.env.NODE_ENV === 'production' ? 0 : 1,
  rendererPackageName: '@spazious/dollhouse-fiber',
  version: React.version,
});

export { updateContainer, createContainer };
